export default "__VITE_ASSET__HmxVqC0C__"